/* =========================================================
   PP-TRACK — analítica ligera Prendas Payas
   Captura: pageviews, clicks (con coords %), dead clicks,
   rage clicks, scroll depth, duración de sesión, dispositivo,
   add-to-cart. Todo en localStorage (por navegador).

   Herramientas:
   - ?pp-heat  → overlay de mapa de calor sobre la página actual
   - ?pp-panel → panel rápido de stats
   - window.__ppExport() → copia el JSON al portapapeles
     (pégalo en el dashboard "Prendas Payas Monitor")
   ========================================================= */
(function () {
  'use strict';
  var KEY = 'pp_stats_v1';
  var MAX = 5000; // tope de eventos guardados

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || { v: 1, ev: [] }; }
    catch (_) { return { v: 1, ev: [] }; }
  }
  function save(d) {
    if (d.ev.length > MAX) d.ev = d.ev.slice(d.ev.length - MAX);
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (_) {}
  }

  var data = load();
  var path = location.pathname;
  var device = innerWidth < 700 ? 'movil' : (innerWidth < 1100 ? 'tablet' : 'desktop');
  var t0 = Date.now();
  var pend = []; // eventos pendientes de guardar (batch)
  var saveTimer = null;

  function push(e) {
    e.t = Date.now();
    e.p = path;
    pend.push(e);
    if (!saveTimer) saveTimer = setTimeout(flush, 800);
  }
  function flush() {
    saveTimer = null;
    if (!pend.length) return;
    data.ev = data.ev.concat(pend);
    pend = [];
    save(data);
  }

  /* --- pageview --- */
  push({ k: 'pv', d: device, w: innerWidth, h: innerHeight, r: document.referrer.replace(/^https?:\/\//, '').split('/')[0] || '' });

  /* --- clicks + dead + rage --- */
  var lastClicks = []; // timestamps para rage
  document.addEventListener('click', function (e) {
    var el = e.target.closest('a,button,[role="button"],input,summary,label') || e.target;
    var tag = el.tagName ? el.tagName.toLowerCase() : '?';
    var sel = tag;
    if (el.id) sel += '#' + el.id;
    else if (el.className && typeof el.className === 'string') sel += '.' + el.className.trim().split(/\s+/).slice(0, 2).join('.');
    var txt = (el.textContent || '').trim().slice(0, 40);
    var interactivo = !!e.target.closest('a,button,[role="button"],input,select,textarea,summary,label,details,[onclick]');

    // rage: 3+ clicks en <700ms en la misma zona
    var now = Date.now();
    lastClicks = lastClicks.filter(function (c) { return now - c.t < 700 && Math.abs(c.x - e.pageX) < 40 && Math.abs(c.y - e.pageY) < 40; });
    lastClicks.push({ t: now, x: e.pageX, y: e.pageY });
    var rage = lastClicks.length >= 3;

    // dead: click no interactivo Y sin cambio de DOM/URL en 600ms
    var ev = {
      k: 'c',
      x: +(e.pageX / document.documentElement.scrollWidth * 100).toFixed(2),
      y: +(e.pageY / Math.max(document.documentElement.scrollHeight, 1) * 100).toFixed(2),
      vx: +(e.clientX / innerWidth * 100).toFixed(2),
      vy: +(e.clientY / innerHeight * 100).toFixed(2),
      s: sel, tx: txt, d: device
    };
    if (rage) ev.rage = 1;
    if (!interactivo) {
      var urlAntes = location.href;
      var htmlAntes = document.body.childElementCount + '|' + document.documentElement.className;
      setTimeout(function () {
        var cambio = location.href !== urlAntes || (document.body.childElementCount + '|' + document.documentElement.className) !== htmlAntes;
        if (!cambio) ev.dead = 1;
        push(ev);
      }, 600);
    } else {
      push(ev);
    }
  }, { capture: true, passive: true });

  /* --- add to cart (form de producto + quick add) --- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && /\/cart\/add/.test(f.action || '')) push({ k: 'atc', s: path });
  }, true);

  /* --- scroll depth --- */
  var maxScroll = 0;
  addEventListener('scroll', function () {
    var dh = document.documentElement.scrollHeight - innerHeight;
    if (dh <= 0) return;
    var pct = Math.round(scrollY / dh * 100);
    if (pct > maxScroll) maxScroll = Math.min(pct, 100);
  }, { passive: true });

  /* --- fin de sesión de página --- */
  addEventListener('pagehide', function () {
    pend.push({ k: 'fin', t: Date.now(), p: path, dur: Math.round((Date.now() - t0) / 1000), sc: maxScroll, d: device });
    flush();
  });

  /* --- export --- */
  window.__ppExport = function () {
    flush();
    var json = JSON.stringify(load());
    if (navigator.clipboard) navigator.clipboard.writeText(json).then(function () {
      console.log('[pp-track] JSON copiado al portapapeles — pégalo en el dashboard');
    });
    return json;
  };
  window.__ppReset = function () { localStorage.removeItem(KEY); console.log('[pp-track] datos borrados'); };

  /* =====================================================
     OVERLAY DE CALOR — ?pp-heat en la URL
     ===================================================== */
  if (/pp-heat/.test(location.search)) {
    cuando(function () {
      var cv = document.createElement('canvas');
      cv.style.cssText = 'position:absolute;top:0;left:0;z-index:99998;pointer-events:none;';
      cv.width = document.documentElement.scrollWidth;
      cv.height = document.documentElement.scrollHeight;
      document.body.appendChild(cv);
      var ctx = cv.getContext('2d');
      var clicks = load().ev.filter(function (e) { return e.k === 'c' && e.p === path; });
      clicks.forEach(function (c) {
        var x = c.x / 100 * cv.width, y = c.y / 100 * cv.height;
        var g = ctx.createRadialGradient(x, y, 2, x, y, 34);
        var col = c.dead ? '220,40,40' : (c.rage ? '255,120,0' : '201,168,76');
        g.addColorStop(0, 'rgba(' + col + ',0.5)');
        g.addColorStop(1, 'rgba(' + col + ',0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(x, y, 34, 0, 7); ctx.fill();
      });
      var info = document.createElement('div');
      info.style.cssText = 'position:fixed;bottom:12px;left:12px;z-index:99999;background:#050505;color:#f0ebe0;font:12px monospace;padding:8px 12px;border:1px solid #c9a84c;border-radius:6px;';
      info.textContent = clicks.length + ' clicks · dorado=normal · rojo=dead · naranja=rage';
      document.body.appendChild(info);
    });
  }

  /* =====================================================
     PANEL RÁPIDO — ?pp-panel en la URL
     ===================================================== */
  if (/pp-panel/.test(location.search)) {
    cuando(function () {
      var d = load();
      var pv = d.ev.filter(function (e) { return e.k === 'pv'; }).length;
      var cl = d.ev.filter(function (e) { return e.k === 'c'; });
      var dead = cl.filter(function (e) { return e.dead; }).length;
      var rage = cl.filter(function (e) { return e.rage; }).length;
      var atc = d.ev.filter(function (e) { return e.k === 'atc'; }).length;
      var fins = d.ev.filter(function (e) { return e.k === 'fin'; });
      var dur = fins.length ? Math.round(fins.reduce(function (a, e) { return a + (e.dur || 0); }, 0) / fins.length) : 0;
      var el = document.createElement('div');
      el.style.cssText = 'position:fixed;top:12px;right:12px;z-index:99999;background:#0f0f0f;color:#f0ebe0;font:13px monospace;padding:14px 18px;border:1px solid #c9a84c;border-radius:8px;line-height:1.7;box-shadow:0 10px 30px rgba(0,0,0,.6)';
      el.innerHTML = '<b style="color:#c9a84c">PP STATS (este navegador)</b><br>' +
        'pageviews: ' + pv + '<br>clicks: ' + cl.length + '<br>dead clicks: ' + dead + '<br>rage clicks: ' + rage + '<br>add-to-cart: ' + atc + '<br>t. medio: ' + dur + 's<br>' +
        '<button onclick="__ppExport()" style="margin-top:6px;background:#c9a84c;border:0;padding:5px 10px;border-radius:4px;cursor:pointer;font-family:monospace">copiar JSON</button> ' +
        '<button onclick="this.parentNode.remove()" style="background:transparent;color:#888;border:1px solid #333;padding:5px 8px;border-radius:4px;cursor:pointer">x</button>';
      document.body.appendChild(el);
    });
  }

  function cuando(f) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', f);
    else f();
  }
})();
